<script>
import ChipColors from '@/app/arch/enums/ChipColors';
import DataTableChipColumnVue from './DataTableChipColumn.vue';

export default {
  name: 'DataTableBooleanColumn',
  extends: DataTableChipColumnVue,
  props: {
    value: {
      type: Boolean,
    },
  },
  data: (vm) => ({
    status: vm.handleStatus([
      {
        value: false,
        text: 'Não',
        ...ChipColors.danger,
      },
      {
        value: true,
        text: 'Sim',
        ...ChipColors.success,
      },
    ]),
  }),
};
</script>
